// extracted by mini-css-extract-plugin
export default {"root":"Bidding-root","title":"Bidding-title","description":"Bidding-description","list":"Bidding-list"};